export default class asideSummary{ 

    /**
     * Store
     * @param book_calendar 
     */
    store(book_calendar: any){
        
        // Aside
        const smr_room = document.querySelector('#smr-room') as HTMLSpanElement | null;
        const smr_game = document.querySelector('#smr-game') as HTMLSpanElement | null;
        const smr_date = document.querySelector('#smr-date') as HTMLSpanElement | null;
        const smr_time_slot = document.querySelector('#smr-time-slot') as HTMLSpanElement | null;
        const smr_players = document.querySelector('#smr-players') as HTMLSpanElement | null;
        const smr_type_arena = document.querySelector('#smr-type-arena') as HTMLSpanElement | null;
        const smr_price_paid = document.querySelector('#smr-price-paid') as HTMLSpanElement;
        const smr_price_total = document.querySelector('#smr-price-full') as HTMLSpanElement;
        const smr_price_left = document.querySelector('#smr-price-left') as HTMLSpanElement;
        const smr_price_to_paid = document.querySelector('#smr-price-to-paid') as HTMLSpanElement;

        // Change room
        this.changeRoom(smr_room);

        // Change game
        this.changeGame(smr_game, smr_price_paid, smr_price_total, smr_price_left, smr_price_to_paid);

        // Get date
        this.getDate(book_calendar, smr_date);

        // Change date
        this.changeDate(book_calendar, smr_date);

        // Change time slot
        this.changeTimeSlot(smr_time_slot);

        // Change players
        this.changePlayers(smr_players);

        // Change type arena
        // this.changeTypeArena(smr_type_arena);

    }

    /**
     * Store prices
     * @param prices 
     */
    storePrices(prices: any){
        
        const smr_price_paid = document.querySelector('#smr-price-paid') as HTMLSpanElement;
        const smr_price_total = document.querySelector('#smr-price-full') as HTMLSpanElement;
        const smr_price_left = document.querySelector('#smr-price-left') as HTMLSpanElement;
        const smr_price_to_paid = document.querySelector('#smr-price-to-paid') as HTMLSpanElement;

        const type_arena = document.querySelector<HTMLInputElement>('input[name="field_type_arena"]:checked')?.value;

        if(smr_price_paid === null){
            
            return;
            
        }

        if(smr_price_paid !== null){
            
            if(typeof type_arena !== 'undefined'){

                smr_price_paid.innerHTML = type_arena == 'shared' ? prices.shared.price_paid : prices.full.price_paid;

            }else{
                
                smr_price_paid.innerHTML = '-';

            }
            
        }

        if(smr_price_total !== null){

            if(typeof type_arena !== 'undefined'){

                smr_price_total.innerHTML = type_arena == 'shared' ? prices.shared.price_total : prices.full.price_total;

            }else{
                
                smr_price_total.innerHTML = '-';

            }
            
        }

        if(smr_price_left !== null){

            if(typeof type_arena !== 'undefined'){

                smr_price_left.innerHTML = type_arena == 'shared' ? prices.shared.price_left : prices.full.price_left;

            }else{
                
                smr_price_left.innerHTML = '-';

            }
            
        }

        if(smr_price_to_paid !== null){

            if(typeof type_arena !== 'undefined'){

                smr_price_to_paid.innerHTML = type_arena == 'shared' ? prices.shared.price_paid : prices.full.price_paid;

            }else{
                
                smr_price_to_paid.innerHTML = '-';

            }
            
        }

    }

    /**
     * Change room
     * @param smr_room 
     */
    protected changeRoom(smr_room: HTMLSpanElement | null){
        
        const room_select = document.querySelector('#field_room_vr') as HTMLSelectElement;

        if(room_select === null){
            
            return;
            
        }

        room_select.addEventListener("change", function(e){
            
            e.preventDefault();

            const option = e.target as HTMLOptionElement;
            
            const selectedText = option[this.selectedIndex].text;

            if(smr_room !== null){

                smr_room.innerHTML = selectedText;
                
            }

        });

    }

    /**
     * Change game
     * @param smr_game 
     */
    protected changeGame(
        smr_game: HTMLSpanElement | null,
        smr_price_paid: HTMLSpanElement | null,
        smr_price_total: HTMLSpanElement | null,
        smr_price_left: HTMLSpanElement | null,
        smr_price_to_paid: HTMLSpanElement | null
    ){
        
        const game_select = document.querySelector('#field_game') as HTMLSelectElement;

        if(game_select === null){
            
            return;
            
        }

        game_select.addEventListener("change", function(e){
            
            e.preventDefault();

            const option = e.target as HTMLOptionElement;
            
            const selectedText = option[this.selectedIndex].text;

            if(smr_game !== null){

                smr_game.innerHTML = selectedText;
                
            }

            if(smr_price_paid !== null){

                smr_price_paid.innerHTML = '-';
                
            }

            if(smr_price_total !== null){

                smr_price_total.innerHTML = '-';
                
            }
    
            if(smr_price_left !== null){
                
                smr_price_left.innerHTML = '-';
                
            }

            if(smr_price_to_paid !== null){
                
                smr_price_to_paid.innerHTML = '-';
                
            }

        });

    }

    /**
     * Get date
     * @param book_calendar 
     * @param smr_date 
     */
    protected getDate(book_calendar: any, smr_date: HTMLSpanElement | null) {
        
        if(book_calendar === null){
            
            return;

        }
        
        const val_date = book_calendar.getDate('d-mm-y');
            
        if(typeof val_date !== 'undefined' && smr_date !== null){

            smr_date.innerHTML = val_date;
            
        }

    }

    /**
     * Change date
     * @param book_calendar 
     * @param smr_date 
     */
    protected changeDate(book_calendar: any, smr_date: HTMLSpanElement | null) {
        
        if(smr_date === null){
            
            return;
            
        }
        
        book_calendar.pickerElement.addEventListener('click', (ev) => {
            
            const element = ev.target as Element;
    
            if(!element?.matches('.day')){
                
                return;
                
            }

            const val_date = book_calendar.getDate('d-mm-y');
            
            if(typeof val_date !== 'undefined' && smr_date !== null){

                smr_date.innerHTML = val_date;
                
            }

        });

    }

    /**
     * Change time slot
     * @param smr_time_slot 
     */
    protected changeTimeSlot(smr_time_slot: HTMLSpanElement | null){
        
        const game_select = document.querySelector('#field_time_slot') as HTMLSelectElement;

        if(game_select === null){
            
            return;
            
        }

        game_select.addEventListener("change", function(e){
            
            e.preventDefault();

            const option = e.target as HTMLOptionElement;

            if(smr_time_slot !== null){

                smr_time_slot.innerHTML = option.value;
                
            }

        });

    }

    /**
     * Change players
     * @param smr_players
     */
    protected changePlayers(smr_players: HTMLSpanElement | null){
        
        const players_select = document.querySelector('#field_people') as HTMLSelectElement;

        if(players_select === null){
            
            return;

        }

        players_select.addEventListener("change", function(e){
            
            e.preventDefault();

            const option = e.target as HTMLOptionElement;

            if(smr_players !== null){

                smr_players.innerHTML = option.value.length > 0 ? option.value : '-';
                
            }

        });

    }

    /**
     * Get type arena
     * @param smr_type_arena 
     */
    getTypeArena(){
        
        let inp_cheched = false;

        const smr_type_arena = document.querySelector('#smr-type-arena') as HTMLSpanElement | null;

        if(smr_type_arena === null){
            
            return;

        }
        
        const type_arena_select = document.querySelectorAll<HTMLInputElement>('input[name="field_type_arena"]');

        type_arena_select.forEach(radio => {

            if(radio.checked){
                
                inp_cheched = true;

                const type_arena = radio.value;

                if(smr_type_arena !== null){

                    smr_type_arena.innerHTML = type_arena == 'shared' ? 'Arena condivisa' : 'Arena intera';
                    
                }

            }
            
        });

        if(inp_cheched == false && smr_type_arena !== null){

            smr_type_arena.innerHTML = '-';
            
        }

    }

    /**
     * Set type arena
     */
    setTypeArena(){
        
        const smr_type_arena = document.querySelector('#smr-type-arena') as HTMLSpanElement | null;

        if(smr_type_arena === null){
            
            return;

        }

        if(smr_type_arena !== null){

            smr_type_arena.innerHTML = '-';
            
        }
        
    }

    /**
     * Change type arena
     * @param prices 
     */
    changeTypeArena(prices: any){
        
        const smr_type_arena = document.querySelector('#smr-type-arena') as HTMLSpanElement | null;
        const smr_price_total = document.querySelector('#smr-price-full') as HTMLSpanElement;
        const smr_price_left = document.querySelector('#smr-price-left') as HTMLSpanElement;
        
        const type_arena_select = document.querySelectorAll<HTMLInputElement>('input[name="field_type_arena"]');

        type_arena_select.forEach(radio => {

            radio.addEventListener('change', () => {

                const type_arena = radio.value;

                if(smr_type_arena !== null){

                    smr_type_arena.innerHTML = type_arena == 'shared' ? 'Arena condivisa' : 'Arena intera';
                    
                }

                if(smr_price_total !== null){

                    smr_price_total.innerHTML = type_arena == 'shared' ? prices.shared.price_total : prices.full.price_total;
                    
                }
        
                if(smr_price_left !== null){
        
                    smr_price_left.innerHTML = type_arena == 'shared' ? prices.shared.price_left : prices.full.price_left;
                    
                }

            });
            
        });

    }

}